module.exports = __webpack_public_path__ + "static/media/inv_mid.ade04642.jpeg";